import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-dashboard" }
const _hoisted_2 = { class: "grid sm:grid-cols-1 md:grid-cols-3 gap-4 mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "grid sm:grid-cols-1 md:grid-cols-2 gap-4" }

import { checkProhibitedRoles } from '@/utils/helpers/checkProhibitedRole'
import UpcomingRosterWarning from './components/UpcomingRosterWarning.vue'
import CardTrans from './components/CardTransaction.vue'
import CardVerbal from './components/CardVerbal.vue'
import CardVerpal from './components/CardVerpal.vue'
import CardBus from './components/CardBus.vue'
import CardRit1 from './components/CardRit1.vue'
import CardRit2 from './components/CardRit2.vue'
import CardCondecturHaventDeposit from './components/CardCondecturHaventDeposit.vue'
import CardDriverHaventDeposit from './components/CardDriverHaventDeposit.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UpcomingRosterWarning),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(CardTrans)
      ]),
      _createElementVNode("div", null, [
        (_unref(checkProhibitedRoles)(['Roster']))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(CardVerbal)
            ]))
          : _createCommentVNode("", true),
        (_unref(checkProhibitedRoles)(['Setoran']))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(CardVerpal)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(CardBus)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(CardCondecturHaventDeposit)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createVNode(CardRit1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(CardRit2)
      ])
    ])
  ]))
}
}

})